<template>
  <v-container
    class="fill-height bg"
    fluid
  >
    <v-row 
      align="center"
      justify="center"
    >
      <v-col
        sm="8"
        md="4"
      >
        <v-card class="">
          <v-toolbar
            color="teal lighten-2"
            dark
            flat
          >
          <v-toolbar-title class="text-h7" @click="titleClick">eProc Perumda Pembangunan Sarana Jaya</v-toolbar-title>                        
          </v-toolbar>
          <v-spacer />
          <v-card-text>
            <v-form ref="home">
              <v-text-field
                label="User ID"
                name="userId"
                prepend-icon="person"
                type="text"
                v-model="userId"
                :rules="[rules.required]"
                v-on:keyup.enter="loginClick"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
                v-model="password"
                :rules="[rules.required]"
                v-on:keyup.enter="loginClick"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn dark color="green" @click="loginClick">Login</v-btn>
            <v-btn href="/forget" text class="pa-0">Lupa Password?</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>      
  </v-container>
</template>

<script>
import { rules as Rules } from './../lib/rules'

export default {
  data: function() {
    return {
      userId: '',
      password: '',
      rules: {
        required: Rules.required,
        minPass: Rules.minPass,
        minUserId: Rules.minUserId
      },
      showPass: false
    }
  },
  methods: {
    titleClick: function() {
      this.$router.push('/')
    },
    daftarClick: function() {
      this.$router.push({path: '/registrasi'})
    },
    loginClick: async function() {
      if (this.$refs.home.validate()) { // check validitas input
        // lakukan authentikasi
        this.$store.dispatch('login', { userId: this.userId, password: this.password })
        .then((res) => {
          console.log(res)
          this.$router.push(this.$store.getters.userHome)
        })    
        .catch((err) => {
          console.log(err)
        }) 
      }  
    }
  }
}
</script>

<style scoped>
.bg {
  background: url('./../assets/sarana01.jpg');
  background-size: cover;
}
</style>